<style>
  .modal-header{
    text-transform: capitalize;
  }
  .modal-body {
    padding: 0 1rem;
  }
</style>

<style scoped>
  .form-control{
    border: none;
    background: #eee;
    font-size: 1.2em;
    color: #000;
  }

  h4{
    font-weight: 500;
    color: #555;
  }

  textarea{
    resize: none;
  }

  #sideBar{
    position: fixed;
    top: 55px;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: stretch;
    justify-content: flex-end;
    transition: background 0.2s ease-out;
  }

  #sideBar.open{
    background: rgba(0, 0, 0, 0.2);
  }

  #sideBarContent{
    padding: 2rem 0;
    padding-top: 80px;
    background: #fff;
    width: 450px;
    box-shadow: -5px 0 10px rgba(0, 0, 0, 0.2);
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    transition: transform 0.2s ease-out;
  }

  #sideBarContent::-webkit-scrollbar {
    width: 8px;
  }
  
  #sideBarContent::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  
  #sideBarContent::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
  }

  #sideBarContent > *:not(#closeButton){
    padding: 0 2rem;
  }

  #sideBar:not(.open) #sideBarContent{
    transform: translateX(100%);
    opacity: 0;
  }

  #guarantors .badge-pill{
    padding: 0.3rem 0.6rem;
    padding-bottom: 0.4rem;
  }

  #paymentSchedule{
    position: relative;
    padding-left: 2rem;
  }
  
  #paymentSchedule:before{
    content: '';
    position: absolute;
    top: 18px;
    bottom: 47px;
    left: 4px;
    width: 2px;
    background: #e9e9e9;
  }
  
  #paymentSchedule .list-group-item{
    position: relative;
    margin-bottom: 2rem;
    background: #f9fafb;
  }
  
  #paymentSchedule .list-group-item:before{
    content: '';
    position: absolute;
    top: 17px;
    left: -34px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ddd;
  }

  #paymentSchedule p{
    font-weight: 500;
    color: #777;
  }

  #paymentSchedule p span{
    border-radius: 60px;
  }
  
  #paymentSchedule p span.error{
    color: #e06f6f;
  }
  
  #paymentSchedule p span.success{
    color: #51ac70;
  }

  #closeButton{
    position: fixed;
    z-index: 1;
    top: 65px;
    margin-left: 10px;
    background: #ededed;
    border-radius: 50%;
    font-size: 1.2rem;
  }
</style>

<template>
  <div ref="wrapper" id="sideBar" :visible="loanApplicationId !== null">
    <div id="sideBarContent">
      <router-link id="closeButton" class="btn btn-default" :to="`/loanApplications`">
        <i class="fa fa-close"></i>
      </router-link>

      <Loader v-if="!currentLoan" :size="40" />

      <template v-else>
        <p class="mb-1 text-uppercase">Applicant</p>
        <h2 class="mb-3">
          {{ currentLoan.applicant.displayName }}
        </h2>

        <p class="mb-1 text-uppercase">Amount Requested</p>
        <h2 class="mb-4">
          <small>Tshs.</small> {{ parseInt(currentLoan.amount).toLocaleString() }}/-
        </h2>

        <hr/>

        <b-row class="mt-4">
          <b-col md="6">
            <p class="mb-1 text-uppercase">Requested On</p>
            <h4>
              {{ currentLoan.createdAt }}
            </h4>
          </b-col>
          <b-col>
            <p class="mb-1 text-uppercase">Loan Purpose</p>
            <h4 class="text-capitalize">
              {{ currentLoan.reason }}
            </h4>
          </b-col>
        </b-row>
        
        <b-row class="mt-3 mb-3">
          <b-col m="12">
            <p class="mb-1 text-uppercase">Status</p>
            <h4 class="text-capitalize">
              {{ currentLoan.status }}
            </h4>
          </b-col>
          <b-col>
            <p class="mb-1 text-uppercase">Last Updated</p>
            <h4 class="text-capitalize">
              {{ currentLoan.updatedAt }}
            </h4>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col md="12">
            <p class="mb-1 text-uppercase">Payment Schedule</p>
            <h4 v-if="currentLoan" class="mt-2">
                <span style="text-transform: capitalize;">{{currentLoan.repaymentFrequency}}</span>
                for {{currentLoan.repaymentInstallments}} {{currentLoan.repaymentFrequency.replace('ly', 's').toLowerCase()}}
            </h4>
          </b-col>
        </b-row>

        <hr/>

        <h5 class="mt-4 text-capitalize" style="font-weight: normal">
          Guarantors
        </h5>

        <div id="guarantors" class="mb-4">
          <span v-if="!currentLoan.guarantors.every(({user}) => user.displayName)">
            No guarantors
          </span>

          <b-list-group v-else>
            <b-list-group-item class="d-flex justify-content-between align-items-center"
              v-for="guarantor in currentLoan.guarantors" :key="guarantor._id">
              {{guarantor.user.displayName}}

              <span v-if="guarantor.status === 'guaranteed' || guarantor.status === 'guranteed'">
                {{parseInt(guarantor.amount).toLocaleString()}}
              </span>

              <b-badge v-else pill :variant="guarantor.status == 'rejected' ? 'danger' : ''">
                {{ guarantor.status }}
              </b-badge>
            </b-list-group-item>
          </b-list-group>
        </div>

        <div style="padding: 0; padding-top: 0.7rem; padding-bottom: 0.3rem;">
          <hr style="margin: 0" />
        </div>

        <div class="mb-2">
          <h5 class="mt-2 pb-1 text-capitalize" style="font-weight: normal">
            Actions
          </h5>

          <template v-if="currentLoan.status === 'disbursementInitiated'">
            <button class="btn btn-primary"
              v-has-permissions="[PERMISSIONS.APPROVE_DISBURSEMENT]"
              :class="{'disabled': currentLoan.approving}"
              @click="approveLoan">
              {{ currentLoan.approving ? 'Approving...' : 'Approve' }}
            </button>
            &emsp;

            <button class="btn btn-danger" 
              v-has-permissions="[PERMISSIONS.REJECT_DISBURSEMENT]"
              :class="{'disabled': currentLoan.rejecting}"
              @click="rejectLoanDisburseMent">
              {{ currentLoan.rejecting ? 'Rejecting...' : 'Reject Disbursement' }}
            </button>
          </template>

          <!-- <button v-else-if="loanCanBeRejected"
            v-has-permissions="[PERMISSIONS.REJECT_LOANS]"
            class="btn btn-danger"
            :class="{'disabled': savingLoanApplication}"
            @click="rejectLoan">
            {{ savingLoanApplication ? 'Rejecting...' : 'Reject' }}
          </button> -->

          <template v-else-if="loanCanBeBroadcasted">
            <button v-if="!maxAmount"
              v-has-permissions="[PERMISSIONS.BROADCAST_LOANS]"
              class="btn btn-primary"
              :class="{'disabled': savingLoanApplication}"
              @click="maxAmount = 10">
              {{ savingLoanApplication ? 'Broadcasting...' : 'Broadcast' }}
            </button>

            <div v-else class="mt-2 px-4 pt-3 pb-2" style="background: #fff; border-radius: 20px; box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3)">
              <h4 class="d-block mb-3">Set max guarantee amount</h4>
              <vue-slider v-model="maxAmount" />
              <div class="d-flex justify-content-between align-items-center">
                <h1 class="mt-3">{{ maxAmount }}%</h1>
                <button
                  class="btn btn-primary"
                  :class="{'disabled': savingLoanApplication}"
                  @click="broadcastLoan">
                  {{ savingLoanApplication ? 'Broadcasting...' : 'Broadcast' }}
                </button>
              </div>
            </div>
          </template>
          
          <button v-else-if="currentLoan.status === 'guaranteed'"
            v-has-permissions="[PERMISSIONS.DISBURSE_LOANS]"
            class="btn btn-primary"
            :class="{'disabled': savingLoanApplication}"
            @click="disburseLoan">
            {{ savingLoanApplication ? 'Disbursing...' : 'Disburse' }}
          </button>
          
          <button v-else-if="loanCanBeRejected"
            v-has-permissions="[PERMISSIONS.REJECT_LOANS]"
            class="btn btn-danger"
            :class="{'disabled': savingLoanApplication}"
            @click="rejectLoan">
            {{ savingLoanApplication ? 'Rejecting...' : 'Reject' }}
          </button>

          <span v-else>
            No actions available
          </span>
        </div>

        <hr />

        <div>
          <h5 class="mt-4 text-capitalize" style="font-weight: normal">
            Repayment Plan
          </h5>

          <div v-if="currentLoan.status !== 'disbursementApproved' || !loanRepaymentSchedule.length" 
            class="bg-light mt-3" style="padding: 0.6rem 0.8rem">
              Repayment schedule will appear once the application is approved.
          </div>

          <div v-else id="paymentSchedule" class="mt-3">
            <b-list-group-item class="flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">
                  1st Installment
                </h5>
              </div>

              <p class="mb-1">
                <small>Due On:</small> May 3rd &nbsp; &middot; &nbsp; <small>Paid On:</small> &nbsp; <span class="error">May 14th</span>
              </p>
            </b-list-group-item>
            
            <b-list-group-item class="flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">
                  2nd Installment
                </h5>
              </div>

              <p class="mb-1">
                <small>Due On:</small> June 3rd &nbsp; &middot; &nbsp; <small>Paid On:</small> &nbsp; <span class="error">June 8th</span>
              </p>
            </b-list-group-item>
            
            <b-list-group-item class="flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">
                  3rd Installment
                </h5>
              </div>

              <p class="mb-1">
                <small>Due On:</small> July 3rd &nbsp; &middot; &nbsp; <small>Paid On:</small> &nbsp; <span class="success">July 4rd</span>
              </p>
            </b-list-group-item>
            
            <b-list-group-item class="flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">
                  4th Installment
                </h5>
              </div>

              <p class="mb-1">
                <small>Due On:</small> Aug 3rd
              </p>
            </b-list-group-item>
            
            <b-list-group-item class="flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">
                  5th Installment
                </h5>
              </div>

              <p class="mb-1">
                <small>Due On:</small> Sep 3rd
              </p>
            </b-list-group-item>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import VueSlider from 'vue-slider-component';
  import 'vue-slider-component/theme/default.css';
  import { PERMISSIONS } from '@/permissions';

  export default {
    name: 'RejectcastLoanApplication',
    props: {
      loanApplicationId: {
        type: String,
        required: true
      }
    },
    mounted(){
      setTimeout(() => {
        this.$refs.wrapper.classList.add("open");
      }, 10);

      this.$store.dispatch('setcurrentLoan', this.loanApplicationId);
    },
    beforeDestroy(){
      this.$refs.wrapper.classList.remove("open");
      this.$store.dispatch('setcurrentLoan', null);
    },
    data(){
      return {
        PERMISSIONS,
        maxAmount: null,
        remark: 'Applicant has bad credit',
        saving: false
      }
    },
    computed: {
      ...mapState(['loanApplications', 'fetchingLoanApplications', 'savingLoanApplication']),
      currentLoan () {
        return this.$store.getters.currentLoanApplication
      },
      loanRepaymentSchedule(){
        if(!this.currentLoan)
          return [];

        const loan = this.currentLoan;

        if(loan.status !== "disbursementApproved")
          return [];

        const payments = loan.transactions.filter(({type}) => type === 'loanrepayment');
        const frequency = loan.repaymentFrequency; // monthly, weekly
        const installments = loan.repaymentInstallments;

        if(payments && frequency && installments);
          return [];
      },
      loanCanBeRejected(){
        if(!this.currentLoan)
          return false;

        const loan = this.currentLoan;
        const status = loan.status;

        if(status === 'rejected' || status === 'disbursementApproved')
          return false;

        return true;
      },
      loanCanBeBroadcasted(){
        if(!this.currentLoan)
          return false;

        const loan = this.currentLoan;
        const status = loan.status;
        if(status !== "pending")
          return false;
        
        const respondedGuarantors = loan.guarantors.filter(({status}) => status !== "pending");
        if(!respondedGuarantors.length)
          return true;

        const guaranteedAmount = respondedGuarantors.reduce((sum, {amount}) => sum + amount, 0);
        if(guaranteedAmount >= loan.amount)
          return false;
        
        // if all conditions pass but some guarantors have not responded
        // if(respondedGuarantors.length !== loan.guarantors.length)
        //   return false;
        
        return true;
      }
    },
    watch: {
      currentLoan: function(supportedBank){
        if(!supportedBank)
          return;
      }
    },
    methods: {
      close(){
        this.$router.replace('/loanApplications');
      },
      broadcastLoan(){
        if(!this.currentLoan)
          return;

        const data = {
          loanId: this.currentLoan._id,
          maxAmount: this.maxAmount
        };

        this.$store.dispatch('broadcastLoanApplication', data);
      },
      disburseLoan(){
        if(!this.currentLoan)
          return;

        this.$store.dispatch('disburseLoanApplication', this.currentLoan._id);
      },
      approveLoan(){
        console.log("Approve Loan: ", this.currentLoan);
        if(!this.currentLoan)
          return;
        
        const transactions = this.currentLoan.transactions;
        if(!transactions || !transactions.length){
          console.log("No loan transactions found!");
          return;
        }


        const disburseMentTransaction = transactions.find(({type}) => type === "loanDisbursment");

        if(disburseMentTransaction){
          this.$store.dispatch('approveLoanApplication', {
            transactionId: disburseMentTransaction._id,
            loanApplicationId: this.currentLoan._id
          });
        }
      },
      rejectLoan(){
        console.log("Reject loan: ", this.currentLoan);
        if(!this.currentLoan)
          return;
        
        this.$store.dispatch('rejectLoanApplication', this.currentLoan._id);
      },
      rejectLoanDisburseMent(){
        if(!this.currentLoan)
          return;
          
        console.log("Reject loan: ", this.currentLoan);
        const transactions = this.currentLoan.transactions;
        if(!transactions || !transactions.length)
          return;

        const disburseMentTransaction = transactions.find(({type}) => type === "loanDisbursment");

        if(disburseMentTransaction){
          this.$store.dispatch('rejectLoanDisbursement', {
            transactionId: disburseMentTransaction._id,
            loanApplicationId: this.currentLoan._id,
            remark: this.remark
          });
        }
      }
    },
    components: {
      VueSlider
    }
  }
</script>
